var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.listLoading,
              expression: "listLoading",
            },
          ],
          staticClass: "box-card",
        },
        [
          _c(
            "el-form",
            { ref: "pram", attrs: { "label-width": "150px", model: _vm.pram } },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("lbmc"),
                    prop: "remark",
                    rules: [
                      {
                        required: true,
                        message: "请选择轮播名称",
                        trigger: ["blur"],
                      },
                    ],
                  },
                },
                [
                  _c("el-input", {
                    attrs: { placeholder: _vm.$t("qsrlbmc") },
                    model: {
                      value: _vm.pram.remark,
                      callback: function ($$v) {
                        _vm.$set(_vm.pram, "remark", $$v)
                      },
                      expression: "pram.remark",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("isShowText"), prop: "status" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.pram.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.pram, "status", $$v)
                        },
                        expression: "pram.status",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 0 } }, [
                        _vm._v(_vm._s(_vm.$t("fou"))),
                      ]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: 1 } }, [
                        _vm._v(_vm._s(_vm.$t("shi"))),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("faTime"),
                    prop: "start_time",
                    rules: [
                      {
                        required: true,
                        message: _vm.$t("qxzfaTime"),
                        trigger: ["change"],
                      },
                    ],
                  },
                },
                [
                  _c("el-date-picker", {
                    attrs: {
                      type: "datetime",
                      "value-format": "yyyy-MM-dd hh:mm:ss",
                      format: "yyyy-MM-dd hh:mm:ss",
                      placeholder: _vm.$t("xzfaTime"),
                    },
                    model: {
                      value: _vm.pram.start_time,
                      callback: function ($$v) {
                        _vm.$set(_vm.pram, "start_time", $$v)
                      },
                      expression: "pram.start_time",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("endTime"),
                    prop: "end_time",
                    rules: [
                      {
                        required: true,
                        message: _vm.$t("qxzendTime"),
                        trigger: ["change"],
                      },
                    ],
                  },
                },
                [
                  _c("el-date-picker", {
                    attrs: {
                      type: "datetime",
                      "value-format": "yyyy-MM-dd hh:mm:ss",
                      format: "yyyy-MM-dd hh:mm:ss",
                      placeholder: _vm.$t("qxzendTime"),
                    },
                    model: {
                      value: _vm.pram.end_time,
                      callback: function ($$v) {
                        _vm.$set(_vm.pram, "end_time", $$v)
                      },
                      expression: "pram.end_time",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("jjnr"),
                    prop: "value",
                    rules: [
                      {
                        required: true,
                        message: _vm.$t("qsrjjnr"),
                        trigger: ["blur", "change"],
                      },
                    ],
                  },
                },
                [
                  _c("Tinymce", {
                    model: {
                      value: _vm.pram.value,
                      callback: function ($$v) {
                        _vm.$set(_vm.pram, "value", $$v)
                      },
                      expression: "pram.value",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "dialog-footer flex-end" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.submitForm()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("trueText")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }